import React, { useEffect, useContext, useRef } from "react";
import Loader from "../Shared/Loader/loader";
import { Splitter } from "@progress/kendo-react-layout";
import InnerLoader from "../Shared/Loader/InnerLoader";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import Rights from "./Rights";
import { PageContainer, Content, Header } from "../Drawer/PageContainer";
import RemoveDialog from "../Shared/Remove/RemoveDialog";
import ErrorMessage from "../Shared/Error/ErrorMessage";
import Scrollable from "../Shared/Edit/Scrollable";
import { OverlayLoader } from "../Shared/Loader/OverlayLoader"
import { RoleContext } from "./Context/RoleContext";
import { callApiWithAuthorization } from "../../API/CallApi";
import { GlobalContext } from "../../Renderers/GlobalContext"
import { removeSpecialCharacters } from "../Entities/utils";
import { useTranslation } from "react-i18next";
import { CheckForInternalUser } from "../Helpers/miscellaneous";
import { createRole, getProjectRoles, updateRole } from "../../API/Role/Role";

class DragCell extends React.Component {
	render() {
		return (
			<td
				className="dragCell"
				onDragOver={(e) => {
					DragCell.reorder(this.props.dataItem)
					e.preventDefault()
					e.dataTransfer.dropEffect = "copy"
				}}
				onDragEnd={(e) => {
					e.preventDefault()
					DragCell.endDrag(this.props.dataItem)
				}}
			>
				<span
					draggable="true"
					style={{ cursor: "move" }}
					onDragStart={(e) => {
						DragCell.dragStart(this.props.dataItem)
						e.dataTransfer.setData("dragging", "")
					}}
				>
					{this.props.dataItem.indexId}
				</span>
			</td>
		)
	}
}

const Roles = (props) => {

	const { state, dispatch } = useContext(RoleContext)
	const { subscription, organization, user } = useContext(GlobalContext).state

	let isInternalUser = CheckForInternalUser(user.email)

	const createRoleButton = useRef()
	const createRoleandNewButton = useRef()
	const roleNameInput = useRef()

	const { t, i18n } = useTranslation([
		"role/common",
		"role/role_dialog",
		"role/delete_dialog",
	], {
		useSuspense: false
	})

	useEffect(() => {
		// i18n.changeLanguage(organization.platformLanguage)
		getRoles()
	}, [])

	const getRoles = async () => {
		let roles = await getProjectRoles(props.project._id)
		for (let i = 0; i < roles.length; i++) {
			roles[i].indexId = i + 1;
		}
		dispatch({
			type: "SET_INTIAL_DATA", payload: {
				data: roles,
				loading: false,
				advancedMode: props.project.developerMode,
				selectedRole: roles.length > 0 ? props.roleId ? roles.find(role => role._id === props.roleId) : roles[0] : {},
				panes: roles.length > 0 ?
					[
						{ size: "20%", min: "15%", collapsible: false },
						{ min: "70%", collapsible: false }
					]
					:
					[
						{ size: "100%", min: "15%", collapsible: false },
						{ min: "0%", collapsible: false }
					]
			}
		})
	}

	const selectItem = (dataItem) => {
		if (state.selectedRole._id !== dataItem._id) {
			dispatch({ type: "SET_SELECTED_ROLE", payload: dataItem })
		}
	}

	const setUpdateItem = (dataItem) => {
		selectItem(dataItem)
		dispatch({ type: "SET_UPDATING_ROlE", payload: dataItem })
	}

	const DeleteConfirmation = (data) => {
		dispatch({ type: "TOGGLE_DELETE_ROLE_DIALOG" })
		dispatch({ type: "SET_DELETING_ROlE", payload: data })
	}

	const handleChangeRoleName = (event) => {
		let { nameError } = state;
		let roleName = event.target.value.trim()
		if (roleName === "") {
			nameError.isValid = false
			nameError.message = t("errors.name_required", { ns: "role/role_dialog" })
		} else if (roleName.match(/^\d/)) {
			nameError.isValid = false
			nameError.message = t("errors.name_starts_with_number", { ns: "role/role_dialog" })
		} else {
			let exists = state.data.find((x) => (
				removeSpecialCharacters(x.roleName.trim().toLowerCase()) === removeSpecialCharacters(roleName.toLowerCase())
			));
			if (exists) {
				nameError.isValid = false
				nameError.message = t("errors.name_already_exists", { ns: "role/role_dialog" })
			} else {
				nameError.isValid = true
				nameError.message = ""
			}
		}
		dispatch({
			type: "HANDLE_ROLE_NAME_CHANGE",
			payload: {
				roleName: event.target.value,
				nameError: nameError
			}
		})
	}

	const onCreate = async (e, keepFormVisible = false) => {
		e.preventDefault()
		createRoleButton.current.disabled = true
		createRoleandNewButton.current.disabled = true

		dispatch({ type: "SET_LOADER", payload: true })

		let order = state.data.length > 0 ? parseInt(state.data[state.data.length - 1]["order"]) : 0

		let result = await createRole(props.project._id, {
			roleName: state.roleName.trim(),
			order: order + 10000000000,
			manageUsers: false,
			provideFeedback: true,
			configureApp: false,
			appGeneralSettings: false,
			viewAppasOtherRolesinPublish: false,
			lookupRights: "Access",
			dashboardingRights: "Access",
			reportingRights: "Access",
			viewAppasOtherRoles: false,
			configureAppinPreview: false,
			importRights: false,
			dataAccessRights: false,
			importRightsinPreview: false,
			notificationRights: "Access",
			sharedFormRights: "No access",
			apiRights: false,
			allowTaskWorkflowManagement: "Access",
			internalWorkflowRights: "Access",
		})

		var roleData = state.data
		result.indexId = roleData.length + 1
		roleData.push(result)

		dispatch({
			type: "ADD_ROLE",
			payload: {
				data: roleData,
				showCreateRoleDialog: keepFormVisible,
				roleName: "",
				panes: [
					{ size: "20%", min: "15%", collapsible: false },
					{ min: "70%", collapsible: false },
				],
				toUpdateRole: {},
				toDeleteRole: {},
				nameError: { isValid: true, message: "" },
				processingRole: false
			}
		})
		selectItem(result)
	}

	const CreateAndNew = async (event) => {
		await onCreate(event, true)
		roleNameInput.current.focus()
	}

	const onUpdate = async (e) => {
		e.preventDefault()
		createRoleButton.current.disabled = true
		dispatch({ type: "SET_LOADER", payload: true })

		await updateRole(state.toUpdateRole._id, { roleName: state.roleName })

		let data = state.data
		data.find((x) => x._id === state.toUpdateRole._id).roleName = state.roleName
		let element = data.find((x) => x._id === state.toUpdateRole._id)
		selectItem(element)
		dispatch({
			type: "UPDATE_ROLE",
			payload: {
				processingRole: false,
				data: data,
				toUpdateRole: {},
				showCreateRoleDialog: false
			}
		})
	}

	const deleteRole = async (e) => {
		e.preventDefault()
		e.target.disabled = true
		let roleId = state.toDeleteRole._id

		dispatch({ type: "SET_LOADER", payload: true })

		await callApiWithAuthorization("/api/v0/project/" + props.project._id + "/role/" + roleId, {
			method: "DELETE",
			headers: {
				"Content-Type": "application/json",
			}
		})

		let data = [...state.data]
		let index = data.findIndex((p) => p._id === roleId)
		if (index >= 0) { data.splice(index, 1) }
		for (let i = 0; i < data.length; i++) {
			data[i].indexId = i + 1
		}
		let toGet = 0
		dispatch({
			type: "DELETE_ROLE",
			payload: {
				data: data,
				showDeleteRoleDialog: false,
				processingRole: false
			}
		})
		if (index === 0) {
			if (data.length > 0) {
				selectItem(data[toGet])
			} else {
				selectItem({})
				dispatch({
					type: "HANDLE_SPLITTER_CHANGE",
					payload: [
						{ size: "100%", min: "15%", collapsible: false },
						{ min: "0%", collapsible: false }
					]
				})
			}
		} else {
			toGet = index - 1;
			if (state.selectedRole._id === roleId) {
				selectItem(data[toGet])
			}
		}
	}

	const reorder = (dataItem) => {
		if (this.state.activeItem._id === dataItem._id) {
			if (
				this.state.activeItemIndex !== this.state.draggedOverItemIndex
			) {
				this.setState({ draggedOverItemIndex: -1 });
			}
			return;
		}

		this.setState({
			activeItem: this.state.activeItem,
			draggedOverItemIndex: dataItem.index,
		});
	}

	const updateOrder = (id, orderToUpdate) => {
		updateRole(id, { order: orderToUpdate })
	}

	const endDrag = (dataItem) => {
		let { activeItemIndex, draggedOverItemIndex } = this.state;
		if (draggedOverItemIndex === -1) {
			return;
		}

		let reorderedData = state.data.slice();
		reorderedData.splice(activeItemIndex, 1);
		reorderedData.splice(draggedOverItemIndex, 0, this.state.activeItem);
		let index = draggedOverItemIndex;

		let newOrder;

		if (reorderedData.length > 2) {
			if (index === reorderedData.length - 1) {
				newOrder =
					parseInt(reorderedData[index - 1]["order"]) + 10000000000;
				////console.log(index, newOrder);
				reorderedData[index]["order"] = newOrder;
				updateOrder(reorderedData[index]._id, newOrder);
			} else if (index === 0) {
				newOrder = parseInt(reorderedData[1]["order"]);
				let prevElementOrder = parseInt(reorderedData[2]["order"]);
				let orderToSet = (prevElementOrder + newOrder) / 2;
				reorderedData[index]["order"] = newOrder;
				reorderedData[1]["order"] = orderToSet;
				updateOrder(reorderedData[index]._id, newOrder);
				updateOrder(reorderedData[1]._id, orderToSet);
				////console.log(prevElementOrder, orderToSet, index);
			} else {
				let prevItemOrder = parseInt(reorderedData[index - 1]["order"]);
				let nextItemOrder = parseInt(reorderedData[index + 1]["order"]);
				newOrder = (prevItemOrder + nextItemOrder) / 2;
				reorderedData[index]["order"] = newOrder;
				updateOrder(reorderedData[index]._id, newOrder);
			}
		} else {
			let firstOrder = reorderedData[0]["order"];
			let secondOrder = reorderedData[1]["order"];

			reorderedData[0]["order"] = secondOrder;
			reorderedData[1]["order"] = firstOrder;

			updateOrder(reorderedData[0]._id, secondOrder);
			updateOrder(reorderedData[1]._id, firstOrder);
		}

		for (let i = 0; i < reorderedData.length; i++) {
			reorderedData[i].indexId = i + 1;
		}

		this.setState({
			data: reorderedData,
			selectedRole: this.state.oldSelectedRole,
		});
	}

	const dragStart = (dataItem) => {
		debugger
		let { state } = this.context
		var oldSelectedRole = state.selectedRole
		this.setState({
			data: state.data,
			activeItem: dataItem,
			oldSelectedRole: oldSelectedRole,
			selectedRole: dataItem,
			activeItemIndex: dataItem.index
		})
	}

	if (state.loading) {
		return <Loader />
	}
	return (
		<PageContainer>
			<div className="ml-9 chngBtn">
				{subscription.rolesPermission === "Full access" ?
					<Header
						header={t("header.title")}
						actionText={t("header.buttons.add_role_button_label")}
						showAction={state.data.length !== 0}
						actionClicked={() => dispatch({ type: "TOGGLE_CREATE_ROLE_DIALOG" })}
						showHelpCenter={(isInternalUser && props.project.developerMode) ? true : false}
						user={user}
						helpCenterFor={"Roles"}
					></Header>
					:
					<Header
						header="Roles"
						showHelpCenter={(isInternalUser && props.project.developerMode) ? true : false}
						user={user}
						helpCenterFor={"Roles"}
					>
						<a className="alert alert-warning mb-0 py-2 me-3" rel="noreferrer" href={`/_Payment/${organization._id}`} target="_blank">
							<i class="far fa-bolt me-2"></i>
							{subscription.rolesPermission === "Editable" ?
								t("header.warning_with_subscription_roles_permission_editable")
								:
								t("header.warning_with_subscription_roles_permission_read_only")
							}
						</a>
					</Header>
				}
			</div>
			<Content>
				<Splitter
					onChange={(e) => dispatch({ type: "HANDLE_SPLITTER_CHANGE", payload: e.newState })}
					className="no-scroll w-100"
					panes={state.panes}
				>
					<Scrollable>
						<div style={{ height: "100%" }}>
							{state.showDeleteRoleDialog && (
								<RemoveDialog
									showLoader={state.processingRole}
									toggleDeleteDialog={() => dispatch({ type: "TOGGLE_DELETE_ROLE_DIALOG" })}
									onDelete={deleteRole}
									deleteButtonText={t("buttons.delete_button_label", { ns: "role/delete_dialog" })}
									cancelButtonText={t("buttons.cancel_button_label", { ns: "role/delete_dialog" })}
									message={
										t("warning", {
											ns: "role/delete_dialog",
											roleName: state.data.find((x) => x._id === state.toDeleteRole._id).roleName
										})
									}
									Title={t("delete_title", { ns: "role/delete_dialog" })}
								/>
							)}
							{state.showCreateRoleDialog && (
								<Dialog
									title={state.toUpdateRole._id ? t("update_title", { ns: "role/role_dialog" }) : t("create_title", { ns: "role/role_dialog" })}
									onClose={() => dispatch({ type: "TOGGLE_CREATE_ROLE_DIALOG" })}
								>
									<form onSubmit={state.toUpdateRole._id ? onUpdate : onCreate}>
										<div className="form-label d-inline-block" required>{t("name_field_label", { ns: "role/role_dialog" })}</div>
										<ErrorMessage
											valid={state.nameError.isValid}
											error={state.nameError.message}
										/>
										<input
											value={state.roleName}
											maxLength={64}
											autoFocus={true}
											ref={roleNameInput}
											className="form-control name-text mb-2"
											onChange={handleChangeRoleName}
										/>
										<DialogActionsBar layout="end">
											<small className="mt-1">
												{state.processingRole && (
													<div className="d-inline-block">
														<InnerLoader borderColor="green" />
														<span className="me-4 text-success"></span>
													</div>
												)}
											</small>
											<button
												className="btn btn-secondary me-1"
												type="button"
												onClick={() => dispatch({ type: "TOGGLE_CREATE_ROLE_DIALOG" })}
											>
												{t("buttons.cancel_button_label", { ns: "role/role_dialog" })}
											</button>
											{!state.toUpdateRole._id && (
												<button
													className="btn btn-primary me-1"
													type="button"
													disabled={(state.roleName.trim() === "" || !state.nameError.isValid) ? true : false}
													onClick={CreateAndNew}
													ref={createRoleandNewButton}
												>
													{t("buttons.create_and_new_button_label", { ns: "role/role_dialog" })}
												</button>
											)}
											<button
												className="btn btn-primary"
												type={'submit'}
												onClick={state.toUpdateRole._id ? onUpdate : onCreate}
												ref={createRoleButton}
												disabled={(state.roleName.trim() === "" || !state.nameError.isValid) ? true : false}
											>
												{state.toUpdateRole._id ?
													t("buttons.update_button_label", { ns: "role/role_dialog" })
													:
													t("buttons.create_button_label", { ns: "role/role_dialog" })
												}
											</button>
										</DialogActionsBar>
									</form>
									{state.processingRole && <OverlayLoader />}
								</Dialog>
							)}
							<div className="py-1">
								<Grid
									data={state.data.map(
										(item, index) => ({
											...item,
											selected: item._id === state.selectedRole._id,
											isHovered: index === state.draggedOverItemIndex,
											index,
										})
									)}
									onRowClick={state.inProgressItems.length !== 0 ? null : (e) => { selectItem(e.dataItem) }}
									style={{ maxHeight: "100%", height: "100%" }}
									scrollable="true"
									selectedField="selected"
								>
									<Column
										field="indexId"
										title="#"
										width={40}
										cell={DragCell}
									/>
									<Column
										title={t("grid.header.name")}
										cell={(props) => (
											<td title={props.dataItem.roleName}>
												<span onClick={state.inProgressItems.length !== 0 ? null : () => { selectItem(props.dataItem) }}>
													{props.dataItem.roleName}
													{props.dataItem._id === state.selectedRole._id && state.inProgressItems.length !== 0 && <span className="ms-4"><InnerLoader borderColor="green" /></span>}
												</span>
											</td>
										)}
									/>
									<Column
										width={50}
										cell={(props) => (
											<td>
												{(props.dataItem.selected && props.dataItem.isDefaultRole !== true) ?
													<span className="float-end">
														{subscription.rolesPermission !== "Read only" &&
															<span
																className="link"
																onClick={() => setUpdateItem(props.dataItem)}
															>
																<i className="fas fa-pencil text-primary mx-2"></i>
															</span>
														}
														<span
															className="link"
															onClick={() => DeleteConfirmation(props.dataItem)}
														>
															<i className="fas fa-times text-danger me-2"></i>
														</span>
													</span>
													:
													<span></span>
												}
											</td>
										)}
									/>
								</Grid>
							</div>
						</div>
					</Scrollable>
					<div style={{ height: "100%" }}>
						{state.selectedRole._id !== undefined && (
							<Rights
								{...props}
								projectId={props.project._id}
								projectName={props.project.name}
								organization={organization} />
						)}
					</div>
				</Splitter>
			</Content>
		</PageContainer >
	);
}

export default Roles;
